<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-4 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input 
                  [Type]="'text'" 
                  [Label]="'VRSTASTAVKI.SIFRA.SINGULAR'" 
                  [MaxLength]="8"
                  formControlName="Sifra">
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Sifra.invalid">
                  <span *ngFor="let validation of errorMessages.Sifra">
                    <span class="error-message" *ngIf="fc.Sifra.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
      </div>

      <div class="col-md-8">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input 
              [Type]="'text'" 
              name="txtNaziv" 
              formControlName="Naziv" 
              #focusElement 
              [MaxLength]="200" 
              [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
              [Label]="'VRSTASTAVKI.NAZIV.SINGULAR'">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
              <span *ngFor="let validation of errorMessages.Naziv">
                <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-md-8 col-12">
          <div class="form-group row">
              <div class="col-md-12">
                  <yt-dropdown-picklist 
                      [ModelName]="'tarifa'" 
                      [GetName]="'getFlat'"                                 
                      [GetParameters]="Parameters && Parameters.size > 0 ? Parameters.get(0) : null"
                      [ModelProperty]="'Naziv,AktuelnaStopa'"
                      [OrderBy]="'Sifra'" 
                      [AllowAddNew]="false" 
                      formControlName="TarifaID"
                      [Width]="'600px'" 
                      [Label]="'VRSTASTAVKI.TARIFA.SINGULAR'">                      
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && fc.TarifaID.invalid">
                      <span *ngFor="let validation of errorMessages.TarifaID">
                        <span class="error-message" *ngIf="fc.TarifaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
              </div>
          </div>
      </div> -->
    </div>
    <div class="row">
      <!-- <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input 
              [Type]="'text'" 
              name="txtNaziv" 
              formControlName="Naziv" 
              #focusElement 
              [MaxLength]="200" 
              [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
              [Label]="'VRSTASTAVKI.NAZIV.SINGULAR'">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
              <span *ngFor="let validation of errorMessages.Naziv">
                <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>
          </div>
        </div>
      </div> -->
    
    </div>
    <div class="row">
      <div class="col-md-3 col-12">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-radio-buttons-group
            [Items]="rbItems"
            formControlName="RobaUsluga">
          </yt-radio-buttons-group>
          <div class="form-error" *ngIf="submitted && fc.RobaUsluga.invalid">
            <span *ngFor="let validation of errorMessages.RobaUsluga">
              <span class="error-message" *ngIf="fc.RobaUsluga.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
            </span>
          </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="form-group row">
          <div class="col-md-12">
              <yt-number-input-v3
              name="txtCena"
              formControlName="Cena"
              [Label]="'VRSTASTAVKI.CENA.SINGULAR'"
              [ngClass]="{'is-invalid': submitted && fc.Cena.invalid}">
          </yt-number-input-v3>    
          <div class="form-error" *ngIf="submitted && fc.Cena.invalid">
            <span *ngFor="let validation of errorMessages.Cena">
              <span class="error-message" *ngIf="fc.Cena.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
            </span>
          </div>       
          </div>
        </div>
      </div>

      <div class="col-md-6 col-12">
          <div class="form-group row">
              <div class="col-md-12">
                  <yt-dropdown-picklist 
                      [ModelName]="'tarifa'" 
                      [GetName]="'getFlat'"                                 
                      [ModelProperty]="'SiriOpis'"
                      [OrderBy]="'Sifra'" 
                      [AllowAddNew]="false" 
                      formControlName="TarifaID"
                      [Width]="'600px'" 
                      [Label]="'VRSTASTAVKI.TARIFA.SINGULAR'">                      
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && fc.TarifaID.invalid">
                      <span *ngFor="let validation of errorMessages.TarifaID">
                        <span class="error-message" *ngIf="fc.TarifaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
              </div>
          </div>
      </div>      



    </div>

    <div class="row">
      <div class="col-md-4 col-12">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist 
              [ModelName]="'jedinicamere'" 
              [GetName]="'get'" 
              [ModelProperty]="'Oznaka,Naziv'" 
              [OrderBy]="'Naziv'"
              [AllowAddNew]="false" 
              formControlName="JedinicaMereID" 
              [Label]="'VRSTASTAVKI.JEDINICAMERE.SINGULAR'"
              [ngClass]="{'is-invalid': submitted && fc.JedinicaMereID.invalid}">
            </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.JedinicaMereID.invalid">
              <span *ngFor="let validation of errorMessages.JedinicaMereID">
                <span class="error-message" *ngIf="fc.JedinicaMereID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>      
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input 
              [Type]="'text'" 
              name="txtBarkod" 
              formControlName="Barkod" 
              #focusElement 
              [MaxLength]="13" 
              [Label]="'VRSTASTAVKI.BARKOD.SINGULAR'">
            </yt-input>
            <!-- <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
              <span *ngFor="let validation of errorMessages.Naziv">
                <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-md-8 col-12" [hidden]="true">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist 
              [ModelName]="'kontniplan'" 
              [GetName]="'get'" 
              [ModelProperty]="'Konto,Naziv'"
              [OrderBy]="'Naziv'" 
              [AllowAddNew]="true" 
              [AllowEdit]="true"
              formControlName="KontoID" 
              [Position]="'right'"
              [Width]="'500px'" 
              [Label]="'VRSTASTAVKI.KONTO.SINGULAR'">
            </yt-dropdown-picklist>
          </div>
        </div>
      </div>

    </div>

  </div>
</form>